module.exports = VueBus;